import { useConfig } from '@src/context/config';
import { APIProvider } from '@vis.gl/react-google-maps';

export default function GoogleMapsProvider({ children }) {
  const config = useConfig();
  return (
    <APIProvider apiKey={config?.GOOGLE_API_KEY} libraries={['marker']}>
      { children }
    </APIProvider>
  );
}
